import { ApprovalStatusT } from 'Api/models/ApprovalStatus';

export const MCP_COMPLIANCE_STATUS_LABELS = {
  [ApprovalStatusT.PENDING]: 'In progress',
  [ApprovalStatusT.IN_REVIEW]: 'In review',
  [ApprovalStatusT.APPROVED]: 'Approved',
  [ApprovalStatusT.REJECTED]: 'Rejected',
};
